import { DepotSummary } from './components/depot-summary';
import { Timeline } from "@material-ui/lab";
import { DropSummary } from './components/drop-summary';

export const SummaryTimeline = ({
    route,
    drops,
    isOnlineData
}) => {

    return (
        <Timeline align="left">
            <DepotSummary location={route.startLocation} timeString={route.startString} />
            {drops.map((drop, i) => <DropSummary key={i} drop={drop} isOnlineData={isOnlineData} />)}
            <DepotSummary location={route.stopLocation} timeString={route.stopString} />
        </Timeline>
    );

}